export function startFuseInit() {
  const fusetag = window.fusetag || (window.fusetag = { que: [] })
  fusetag.que.push(function () {
    fusetag.pageInit()
  })
}

export function fuseProcessNewSlots() {
  const fusetag = window.fusetag || (window.fusetag = { que: [] })
  fusetag.que.push(function () {
    fusetag.registerAll()
  })
}

export function fuseLoadSlots() {
  const fusetag = window.fusetag || (window.fusetag = { que: [] })
  fusetag.que.push(function () {
    fusetag.registerAll()
  })
}
